















import InputText from "@/common/components/atoms/InputText.vue";
import { Prop, Vue, Component } from "vue-property-decorator";

@Component({
  components: {
    InputText
  }
})
export default class C01ItemFormExtraProp extends Vue {
  @Prop({ type: String, required: true, default: "" }) id!: string;
  @Prop({ type: String, required: true, default: "" }) label!: string;
  @Prop({ type: String, required: true, default: "" }) value!: string;
  @Prop({ type: String, required: true, default: "" }) placeholder!: string;

  get internalValue() {
    return this.value;
  }
  set internalValue(newValue) {
    if (this.value !== newValue) {
      this.$emit("input", newValue);
    }
  }
}
